import { render, staticRenderFns } from "./BattleCrewRow.vue?vue&type=template&id=393c03ba&scoped=true"
import script from "./BattleCrewRow.vue?vue&type=script&lang=js"
export * from "./BattleCrewRow.vue?vue&type=script&lang=js"
import style0 from "./BattleCrewRow.vue?vue&type=style&index=0&id=393c03ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393c03ba",
  null
  
)

export default component.exports